import React from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import MobileBottomNav from "./Footer/MobileBottomNav";
import {useMediaQuery} from "react-responsive";

function Unauthorized() {

  const isMobile = useMediaQuery({
    query: "(max-width:768px)",
  });

  return (
    <>
      <div className="root_container" id={isMobile ? "isMobile" : null}>
        <Header/>
        <div className="main center_main" id="unauthorized">
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <h1 className="join_title">접근 불가능한 페이지 입니다.</h1>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          <div className="horizontal_line">
          </div>
          {isMobile ? <MobileBottomNav/> : <Footer/>}
        </div>
      </div>
    </>
  );
}

export default Unauthorized;